import { getLocalTimeZone, today } from '@internationalized/date';

import type { DateRangePreset } from './get_past_date_range_presets';

export function getFutureDateRangePresets(): DateRangePreset[] {
  const currentDate = today(getLocalTimeZone());
  const tomorrow = currentDate.add({ days: 1 });
  const nextMonthStartDate = currentDate.set({ day: 1 }).add({ months: 1 });
  const nextMonthEndDate = nextMonthStartDate
    .add({ months: 1 })
    .add({ days: -1 });
  const currentQuarterStartMonth =
    Math.floor((currentDate.month - 1) / 3) * 3 + 1;
  const currentQuarterStartDate = currentDate.set({
    month: currentQuarterStartMonth,
    day: 1,
  });
  const nextQuarterStartDate = currentQuarterStartDate.add({ months: 3 });
  const nextQuarterEndDate = nextQuarterStartDate
    .add({ months: 3 })
    .add({ days: -1 });

  return [
    {
      key: 'today',
      label: 'Today',
      value: { start: currentDate, end: currentDate },
    },
    {
      key: 'tomorrow',
      label: 'Tomorrow',
      value: { start: tomorrow, end: tomorrow },
    },
    {
      key: 'next_week',
      label: 'Next week',
      value: {
        start: currentDate.add({ days: 1 }),
        end: currentDate.add({ days: 7 }),
      },
    },
    {
      key: 'next_month',
      label: 'Next month',
      value: { start: nextMonthStartDate, end: nextMonthEndDate },
    },
    {
      key: 'next_quarter',
      label: 'Next quarter',
      value: { start: nextQuarterStartDate, end: nextQuarterEndDate },
    },
  ];
}
